import React from "react";
import {
  CertificateItem,
  CertificatePreviewModal,
  CertificateText,
  useCertificate,
  useCertificateProgramSelectListQuery,
} from "..";
import {
  ErrorComponent,
  LoadingSpinner,
  ModalLayout,
  PageLayout,
} from "shared";
import ErrorImg from "assets/images/error-robot.png";
import { getSelectedProgram } from "utils";
import shockingImg from "assets/images/shocking-sale.svg";
import { useAppScope, useSupportTicket, MwcdLogoComopent } from "master";
import { useNavigate } from "react-router-dom";

export const CertificateList = ({ isAllCertificate }) => {
  const data = getSelectedProgram();
  const { lanSettings, isMWCD } = useAppScope();
  const certificateProgramName = data?.name;
  const studentBatchId = data?.studentBatchId;
  const {
    selectedProgram,
    setSelectedProgram,
    downloadPdf,
    studentBatchCertificate,
    onCloseModal,
    modalState,
    onOpenModal,
    setClickedTimes,
  } = useCertificate({
    load: true,
    studentBatchId,
    isAllCertificate,
  });
  const { data: program } = useCertificateProgramSelectListQuery({
    load: true,
  });

  const hasCertificate = studentBatchCertificate?.data?.length > 0;

  const titleEndComponent = () => {

    return <>
      {isMWCD && <MwcdLogoComopent customClass="logo-group-mwcd_PD" />}
      {isAllCertificate && !isMWCD && (<div className="select-dropdown-group">
        <select
          className="custom-select-drop"
          value={selectedProgram}
          onChange={(e) =>
            setSelectedProgram((draft) => {
              draft = e.target.value;
              return draft;
            })
          }
        >
          <option value="" selected>
            {CertificateText.AllPrograms[lanSettings?.lan || "en"]}
          </option>
          {program &&
            program?.map((item) => (
              <option value={item.id} key={`program-${item.id}`}>
                {item.name}
              </option>
            ))}
        </select>
      </div>
      )}
    </>
  }
  const stdDetails = getSelectedProgram();
  const { supportTicketsForCertificate } = useSupportTicket();
  const navigate = useNavigate();
  const RaiseTicket = () => {
    supportTicketsForCertificate.mutate({
      message: "Certificate not generated",
      studentBatchId: stdDetails?.studentBatchId || 0,
    });
  };

  const goToPreviousPage = () => {
    if (isMWCD) {
      navigate(-1, { replace: true });
      return
    }
    else setClickedTimes((draft) => {
      return draft + 1;
    });
  };

  return (
    <PageLayout
      breadcrumb={
        !isAllCertificate
          ? [
            {
              label: `${certificateProgramName ? certificateProgramName : ""
                }`,
              location: "/program",
            },
            { label: `${CertificateText.Certificates[lanSettings?.lan || "en"]}` },
          ]
          : [{ label: `${CertificateText.Certificates[lanSettings?.lan || "en"]}` }]
      }
      titleEndComponent={titleEndComponent()}
      title={hasCertificate ? `${CertificateText.Certificates[lanSettings?.lan || "en"]}` : ""}
      isPageEmpty={!hasCertificate}
    >
      <div className="row">
        <div className="col-12">
          <div className="page-grid-items page-grid-items--box grid-item-certificate">
            {studentBatchCertificate?.isLoading ? (
              <div className="d-flex justify-content-center align-items-center w-100">
                <LoadingSpinner />
              </div>
            ) : (
              <>
                {hasCertificate ? (
                  studentBatchCertificate?.data
                    ?.sort((a, b) => b?.isGenerated - a?.isGenerated)
                    ?.map((item) => (
                      <CertificateItem
                        item={item}
                        key={`ProgramName-${item.id}`}
                        onOpenModal={onOpenModal}
                        certificate={isAllCertificate}
                        certificateProgramName={certificateProgramName}
                      />
                    ))
                ) : (
                  <ErrorComponent
                    title={CertificateText.NoCertificate[lanSettings?.lan || "en"]}
                    message={CertificateText.NoCertificateDes[lanSettings?.lan || "en"]}
                    image={ErrorImg}
                    btnLabel={CertificateText.checkAgainLbl[lanSettings?.lan || "en"]}
                    onClick={goToPreviousPage}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {modalState.isOpen && modalState.actionFrom === "openModal" && (
        <CertificatePreviewModal
          onCloseModal={onCloseModal}
          downloadPdf={downloadPdf}
          modalState={modalState}
        />
      )}
      {modalState.isOpen &&
        modalState.actionFrom === "NoCertificateAssigned" && (
          <ModalLayout
            isOpen={
              modalState.isOpen &&
              modalState.actionFrom === "NoCertificateAssigned"
            }
            title={"Still no certificate assigned?"}
            message={modalState?.info?.message}
            onConfirm={RaiseTicket}
            onCancel={onCloseModal}
            icon={shockingImg}
            confirmButtonLabel={"Raise A Ticket"}
            iconClass={"modal-icon-big"}
          />
        )}
    </PageLayout>
  );
};
